<template>
  <div class="absent-list">
    <box :title="$t('absentPerson.absentList')">
      <div class="">
        <v-data-table
          dense
          :disable-sort="true"
          :headers="headers"
          hide-default-footer
          disable-pagination
          :items="absentList"
          item-key="PERNO"
        />
      </div>
    </box>
  </div>
</template>

<script>
export default {
  mounted() {
    this.getAbsentList();
  },
  data() {
    return {
      headers: [
        {
          text: this.$t("absentPerson.PERNO"),
          value: "PERNO",
        },
        {
          text: this.$t("absentPerson.JustName"),
          value: "JustName",
        },
      ],
      absentList: [],
    };
  },
  methods: {
    getAbsentList() {
      this.absentList = this.$route.params.absentList;
    },
  },
};
</script>

<style >
.title {
  color: var(--color-accent);
}
.value {
  color: var(--border-green) !important;
}
</style>